import { QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from 'next-themes'
import { TooltipProvider } from '@/components/ui/tooltip'
import { Toaster } from '@/components/ui/sonner'
import { PointerEventsGuard } from '@/components/pointer-events-guard'
import { ServiceWorkerUpdater } from '@/components/service-worker-updater'
import { getQueryClient } from '@/lib/query-client'

export function Providers({ children }: { children: React.ReactNode }) {
  const queryClient = getQueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider
        attribute="class"
        defaultTheme="dark"
        enableSystem={false}
        disableTransitionOnChange
      >
        <TooltipProvider delayDuration={300}>
          {children}
          <Toaster position="bottom-right" closeButton />
          <PointerEventsGuard />
          {/* Mounted beside the Toaster it uses, and above the org shell, so a
              deploy is announced on the login screen too — not only once
              somebody has navigated into a workspace. */}
          <ServiceWorkerUpdater />
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}
